import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { BookModel } from "@/types";
import { motion } from "framer-motion";
import BookCard from "../books/BookCard";
import { BackIcon } from "@/icons/BackIcon";
import { FullScreenIcon } from "@/icons/FullScreenIcon";
import { useTranslation } from "react-i18next";
import { RootState } from "@/redux-store";
import { SmartBookService } from "@/services/smartBookService";
import { setBook } from "@/redux-store/slices/bookStore";
import { logopath } from "@/configs/appConfig";
import "./bookGroup.scss";
const BookGroup: React.FC = () => {
  const { bookId } = useParams<{ bookId: string }>();
  const { t } = useTranslation("translation", { keyPrefix: "book_detail" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { book } = useSelector((state: RootState) => state.bookReducer);

  const [children, setChildren] = useState<BookModel[]>([]);

  useEffect(() => {
    if (bookId) {
      loadBook(Number(bookId));
    }
  }, [bookId]);

  const loadBook = async (id: number) => {
    const bookDetail = await SmartBookService.getBookById(id);
    dispatch(setBook(bookDetail));
    const groupBooks = await SmartBookService.getGroupBooks(id);
    setChildren(groupBooks);
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  if (!book) return <div>Loading...</div>;

  return (
    <div className="book-group-container library">
      <div className="header">
        <div className="header-logo">
          <button
            className="return-library-btn"
            onClick={() => navigate("/books")}
          >
            <BackIcon className={undefined} />
            {t("return_to_library")}
          </button>
          <img src={logopath} alt="Logo" />
          <div className="right-buttons">
            <button
              className="obro-btn obro-gray-btn"
              onClick={toggleFullscreen}
            >
              <FullScreenIcon className={undefined} color={{ fill: "#fff" }} />
              {t("full_screen")}
            </button>
          </div>
        </div>
      </div>

      <div className="group-book-info">
        <motion.img
          src={book.CoverImageUrl || book.coverImageUrl}
          alt={book.title}
          layoutId={`product2-${book.id}`}
          style={{
            width: "150px",
            height: "auto",
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
        <h1 className="group-title">{book.title}</h1>
      </div>

      <div className="group-book-list">
        <div className="childBooks">
          {children.map((child, index) => (
            <BookCard
              key={`book-item-${index}`}
              index={index}
              book={child}
              handleProductClick={() => navigate(`/book-detail/${child.id}`)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookGroup;
